import { Box, Button, Grid2 } from "@mui/material";
import React, { useState, useEffect } from "react";
import SideBar from "../SideBar/SideBar";
import { useTheme, useMediaQuery } from "@mui/material";
import "../Assistant/Assistant.css";
import "./../CallHistory/CallHistory.css";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import Modal from "@mui/material/Modal";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import DeleteIcon from "@mui/icons-material/Delete";
import { ToastContainer, toast } from "react-toastify";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import './ContactList.css'
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import TuneIcon from "@mui/icons-material/Tune";
import { getCampaignDetail } from "../../services/Campaign";
import Loader from "../Loader";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

const rows = [
  createData("Frozen yoghurt", 159, 6.0, 24, 4.0),
  createData("Ice cream sandwich", 237, 9.0, 37, 4.3),
  // createData('Eclair', 262, 16.0, 24, 6.0),
  // createData('Cupcake', 305, 3.7, 67, 4.3),
  // createData('Gingerbread', 356, 16.0, 49, 3.9),
];
function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#2F024E",
    color: "#fff",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 10,
    border: "none",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: "rgba(226, 186, 253, 0.30)",
    border: "none",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: "none",
  },
}));

const drawerWidth = 300;

const CampaignOverview = () => {
  const notify = () => toast.success("Setup Completed");
  const remove = () => toast.success("Deleted successfully");

  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up("sm"));

  const [pop, setPop] = useState(false);
  const handlePopOpen = () => setPop(true);
  const handlePopClose = () => setPop(false);

  const navigate = useNavigate();

  const location = useLocation();

  // TablePagination-start
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(3);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);

    setPage(0);
  };

  const [campaignDetail, setCampaignDetail] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const campaignId = location?.state?.id;
    getCampaign(campaignId);
    const intervalId = setInterval(() => {
  getCampaignLoad(campaignId);
}, 10000);

return () => clearInterval(intervalId);
  }, []);

  const getCampaignLoad = async (campaignId) => {

    const response = await getCampaignDetail(campaignId);
    if (response?.data?.success === true) {
      setCampaignDetail(response.data.result);
    } 
  };


  const getCampaign = async (campaignId) => {
    setIsLoading(true);
    const response = await getCampaignDetail(campaignId);
    if (response?.data?.success === true) {
      setCampaignDetail(response.data.result);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  const formatCallDuration = (duration) => {

    // Split the input duration like "1min:12secs" into components
    const [minutes, seconds] = duration?.split(":").map((str) => parseInt(str));
    // Return the formatted string
    return `${minutes} min ${seconds} secs`;
  };
  const checkIfDurationGreaterThanOneMinute = (duration) => {
    const [minutes, seconds] = duration?.split(":").map((str) => parseInt(str));

    return minutes > 1 || (minutes === 1 && seconds > 1);
  };

  const checkIfDurationCallAnswer = (duration) => {
    const [minutes, seconds] = duration?.split(":").map((str) => parseInt(str));

    return minutes > 0 || (minutes === 0 && seconds > 1);
  };

  // TablePagination-end
  // Filter
  const [anchorElFilter, setAnchorElFilter] = React.useState(null);
  const open = Boolean(anchorElFilter);
  const handleClickFilter = (event) => {
    setAnchorElFilter(event.currentTarget);
  };
  const handleCloseFilter = () => {
    setAnchorElFilter(null);
  };

  if(isLoading) return <Loader/>

  return (
    <div className="CampaignOverview">
      {/* <Box sx={{ display: isLgUp ? "flex" : "block", marginTop: "20px" }}>
        <SideBar />

        {isLoading===true ? (
          <Loader />
        ) : (
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              p: isLgUp ? 5 : 1,
              width: { sm: `calc(100% - ${drawerWidth}px)` },
              marginTop: isLgUp ? "0px" : "80px",
            }}
          > */}

          {/* {isLoading===true && <Loader/>} */}
            <div className="display-1">
              <h2 style={{ textTransform: "capitalize" }}>{location?.state?.name}</h2>{" "}
              <span className="green mL-10">{location?.state?.status}</span>
            </div>

            <Grid2 container spacing={1} sx={{ alignItems: "center" }}>
              <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <Grid2 container spacing={2} sx={{ alignItems: "center" }}>
                  <Grid2 item size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 3 }}>
                    <div className="Sales-Outbound-Tesla-card mt-20">
                      <h4>Total Call Placed</h4>
                      {campaignDetail?.calldata?.length > 0 ? <h5>{campaignDetail?.data?.totalCall}</h5> : <h5 style={{ fontSize: 21 }}>-</h5>}
                      <p>
                        Represents the total number of Call placed today across.
                      </p>
                    </div>
                  </Grid2>
                  <Grid2 item size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 3 }}>
                    <div className="Sales-Outbound-Tesla-card mt-20">
                      <h4>Total Calls Answered</h4>
                      {/* <h5>3</h5> */}
                      {campaignDetail?.calldata?.length > 0 ? <h5>{campaignDetail?.data?.callAnswer}</h5> : <h5 style={{ fontSize: 21 }}>-</h5>}
                      <p>
                        Represents the total number of call attended today
                        across.
                      </p>
                    </div>
                  </Grid2>
                  <Grid2 item size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 3 }}>
                    <div className="Sales-Outbound-Tesla-card mt-20">
                      <h4>Total Voice minutes consumed</h4>
                      {/* <h5>10</h5> */}
                      <h5 style={{ fontSize: 21 }}>
                        {campaignDetail?.calldata?.length > 0 ? formatCallDuration(campaignDetail?.data?.totalMinutes) : '-'}
                      </h5>
                      <p>Represents the total Voice Minutes Consumed</p>
                    </div>
                  </Grid2>
                </Grid2>
              </Grid2>
              <Grid2
                item
                size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                sx={{ textAlign: "end" }}
              >
                <div className="bg-clr">
                  <Button
                    id="demo-positioned-button"
                    aria-controls={open ? 'demo-positioned-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClickFilter} startIcon={<TuneIcon />}>Filter</Button>
                  <Menu
                    id="demo-positioned-menu"
                    aria-labelledby="demo-positioned-button"
                    anchorEl={anchorElFilter}
                    open={open}
                    onClose={handleCloseFilter}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                  >
                    <MenuItem onClick={handleCloseFilter}>All</MenuItem>
                    <MenuItem onClick={handleCloseFilter}>Warm</MenuItem>
                    <MenuItem onClick={handleCloseFilter}>Cold  </MenuItem>
                  </Menu>
                </div>
              </Grid2>
              <Grid2
                item
                size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                className="mb-20"
              >
                <div className="ContactListTable-main">
                  <TableContainer
                    component={Paper}
                    sx={{ maxHeight: 440, borderRadius: "20px 20px 0px 0px" }}
                  >
                    <Table
                      sx={{ minWidth: 700 }}
                      stickyHeader
                      aria-label="sticky table"
                    >
                      <TableHead>
                        <TableRow>
                          <StyledTableCell align="start">Name</StyledTableCell>
                          <StyledTableCell align="center">
                            Phone Number
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            Call Answered
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            Interested
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            Call duration
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            Status
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            Explore More
                          </StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {campaignDetail?.calldata?.length > 0 ? (
                          campaignDetail?.calldata?.map((row, index) => (
                            <StyledTableRow key={index}>
                              <StyledTableCell component="th" scope="row">
                                <h4> {row.customerName}</h4>
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                <h4>{row?.phoneNumber}</h4>
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                <h4 className="green">
                                  {" "}
                                  {checkIfDurationCallAnswer(
                                    row.duration
                                  )
                                    ? "Yes"
                                    : "No"}
                                </h4>
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                <h4
                                  className={
                                    row?.interest === "Interest"
                                      ? "green"
                                      : "red"
                                  }
                                >
                                  {row?.interest === "Interest" ? "Yes" : "No"}
                                </h4>
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                <h4>{formatCallDuration(row?.duration)}</h4>
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                <h4 className="green" style={{ textTransform: "capitalize" }}>{row?.status}</h4>
                              </StyledTableCell>
                              <StyledTableCell align="center" onClick={() =>
                                navigate("/campaign-details", {
                                  state: { id: row?.callId ,customerName:row?.customerName,status:row?.status,date:row?.date},
                                })
                              }>
                                {" "}
                                <Stack
                                  direction="row"
                                  spacing={2}
                                  sx={{ justifyContent: "center" }}
                                >
                                  {" "}
                                  <Link to="/campaign-details">
                                    {" "}
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="40"
                                      height="22"
                                      viewBox="0 0 40 22"
                                      fill="none"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M1.76172 18.5155C5.6476 15.8802 9.09831 14.3849 12.1138 14.0297C15.1294 13.6744 18.0004 13.6207 20.7268 13.8686L20.7268 18.5879L33.5264 10.8872L20.7268 3.58789L20.7268 8.07333C15.6852 8.09539 11.3991 9.10024 7.86848 11.0879C4.33889 13.0755 2.30331 15.5514 1.76172 18.5155Z"
                                        fill="#707070"
                                        stroke="#707070"
                                        stroke-width="1.76471"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                  </Link>
                                </Stack>
                              </StyledTableCell>
                            </StyledTableRow>
                          ))
                        ) : (
                          <StyledTableCell component="th" scope="row">
                            <h4> No data found!</h4>
                          </StyledTableCell>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <div className="Pagination-main">
                    <TablePagination
                      rowsPerPageOptions={[3, 25, 100]}
                      component="div"
                      count={rows.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </div>
                </div>
              </Grid2>
            </Grid2>
          {/* </Box>
        )}
      </Box> */}
    </div>
  );
};

export default CampaignOverview;
